import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Toaster } from '../components/ui/sonner';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { initLenis, destroyLenis, scrollToTop } from '../lib/scroll';

export const Layout = ({ children }) => {
    const location = useLocation();

    useEffect(() => {
        initLenis();
        return () => destroyLenis();
    }, []);

    useEffect(() => {
        scrollToTop();
    }, [location.pathname]);

    return (
        <div className="min-h-screen bg-navy-900 text-slate-50">
            <Navbar />
            <main>{children}</main>
            <Footer />
            <Toaster theme="light" position="bottom-right" />
        </div>
    );
};
